import { artistCardsSetup } from './artistCards-ui';

const artistCards = document.querySelector('#artistCards');

if (artistCards) {
  artistCardsSetup();
}
